var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.5,
    height: 78,
    viewBox: "0 0 72.5 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.e{fill:none;}.a{stroke:#fff;stroke-width:3px;}.b{fill:#fff;}.c{stroke:#838383;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-737 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(737 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 72.5,
    height: 42.3,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 1.5,
    y: 1.5,
    width: 69.5,
    height: 39.3,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 63,
    height: 35,
    transform: "translate(742 36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 63,
    height: 35,
    transform: "translate(742 75)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 20,
    transform: "translate(746.5 44.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 20,
    transform: "translate(746.5 48.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 20,
    transform: "translate(746.5 52.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 15.301,
    transform: "translate(746.5 63.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 16.301,
    transform: "translate(784.5 44.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 15.301,
    transform: "translate(746.5 67.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 10,
    transform: "translate(790.801 48.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadDocument);
export default __webpack_public_path__ + "static/media/load_document.1989b2a9cc4bcbf370f31c2ff791a6fe.svg";
export { ForwardRef as ReactComponent };